import { ISection } from '@sdk/contracts';
import { Checkbox, CheckboxChangeEvent, Flex, Modal } from 'antd';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ConditionsListWrapper } from './UnsyncSectionConfirmation.styles';

type Props = {
  section: ISection;
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
  onUnsyncSection: () => void;
};

const MODAL_WIDTH = 572;

export const UnsyncSectionConfirmation: React.FC<Props> = ({
  section,
  isModalOpen,
  setIsModalOpen,
  onUnsyncSection
}) => {
  const { t } = useTranslation(['CoursesTranslations', 'DefaultTranslations']);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsConfirmed(e.target.checked);
  };

  const handleCancel = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    setIsConfirmed(false);
    setIsModalOpen(false);
  };

  const handleUnsyncSection = () => {
    setIsConfirmed(false);
    setIsModalOpen(false);
    onUnsyncSection();
  };

  return (
    <Modal
      open={isModalOpen}
      onOk={handleUnsyncSection}
      onCancel={handleCancel}
      title={t('CoursesTranslations:UNSYNC_SECTION')}
      cancelText={t('DefaultTranslations:CANCEL')}
      okText={t('CoursesTranslations:UNSYNC_SECTION')}
      okButtonProps={{ disabled: !isConfirmed }}
      maskClosable={false}
      centered
      width={MODAL_WIDTH}
      wrapProps={{ onClick: (e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation() }}>
      <Flex vertical gap={24}>
        <span>
          <Trans
            i18nKey="CoursesTranslations:UNSYNC_SECTION_CONFIRMATION"
            values={{ name: section.name }}
            components={{ bold: <strong /> }}
          />
        </span>
        <ConditionsListWrapper>
          <span>{t('WHEN_UNSYNCING_SECTION')}</span>
          <ul>
            <li>{t('WHEN_UNSYNCING_SECTION_1')}</li>
            <li>{t('WHEN_UNSYNCING_SECTION_2')}</li>
            <li>{t('WHEN_UNSYNCING_SECTION_3')}</li>
          </ul>
        </ConditionsListWrapper>
        <Checkbox checked={isConfirmed} onChange={handleCheckboxChange}>
          {t('DefaultTranslations:I_CONFIRM_I_UNDERSTAND')}
        </Checkbox>
      </Flex>
    </Modal>
  );
};
